var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from '@emotion/styled';
import { VisualNavigation } from '../../common/components/VisualNavigation';
import { FlexAlignItems, Grid } from '../../common/components/Grid';
import { SliderTitle } from '../../common/components/Text';
import { VisualNavigationType } from './types';
import { useLoadVisualNavigation } from './hooks';
import { CommonVisualNavigationPlaceholder } from './placeholder/CommonVisualNavigationPlaceholder';
var VisualNavigationGrid = styled(Grid)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  overflow: hidden;\n"], ["\n  overflow: hidden;\n"])));
VisualNavigationGrid.defaultProps = {
    py: 0,
    px: 0,
    mb: ['sp_16', 'sp_24', null, 'sp_32'],
    alignItems: FlexAlignItems.CENTER,
};
export var CommonVisualNavigation = function (_a) {
    var __legacy_shop_reboot_max_width = _a.__legacy_shop_reboot_max_width, title = _a.title, seeAllLink = _a.seeAllLink, props = __rest(_a, ["__legacy_shop_reboot_max_width", "title", "seeAllLink"]);
    var _b = useLoadVisualNavigation(props), items = _b.items, loaded = _b.loaded;
    return (React.createElement(CommonVisualNavigationPlaceholder, { ready: loaded, showTitle: !!title },
        React.createElement(VisualNavigationGrid, { "data-testid": "visual-navigation-grid", legacyShopRebootMaxWidth: __legacy_shop_reboot_max_width },
            title && (React.createElement(SliderTitle, { "data-testid": "visual-navigation-title" }, title)),
            React.createElement(VisualNavigation, { seeAllLink: seeAllLink, items: items }))));
};
CommonVisualNavigation.defaultProps = {
    __legacy_shop_reboot_max_width: true,
    type: VisualNavigationType.Default,
    seeAllLink: null,
    urlParams: '',
};
export default CommonVisualNavigation;
var templateObject_1;
